/*
 * Glossy Journey Tracker
 * Records every UTM/ad touch in localStorage and attaches the full ordered
 * chain to the cart as a private attribute (_journey) so it lands on the
 * order's note_attributes. A second attribute (_journey_readable) carries a
 * human-friendly summary for the admin's Additional details — cosmetic only,
 * the dashboard parses _journey exclusively.
 * Fully isolated: no dataLayer, no GTM, no pixels.
 */
(function () {
  "use strict";

  var KEY = "glossy_journey";
  var SYNC_KEY = "glossy_journey_synced";
  var MAX_TOUCHES = 15;
  var DEDUPE_MS = 30 * 60 * 1000; // same touch within 30min = one touch

  function readChain() {
    try {
      var c = JSON.parse(localStorage.getItem(KEY) || "[]");
      return Array.isArray(c) ? c : [];
    } catch (e) {
      return [];
    }
  }

  function saveChain(chain) {
    try {
      localStorage.setItem(KEY, JSON.stringify(chain));
    } catch (e) {}
  }

  function currentTouch() {
    try {
      var p = new URLSearchParams(location.search);
      var src = p.get("utm_source");
      var med = p.get("utm_medium");
      var camp = p.get("utm_campaign");
      var ad = p.get("utm_content");
      var fbclid = p.get("fbclid");
      var gclid = p.get("gclid");

      if (src || camp || ad || fbclid || gclid) {
        return {
          t: Date.now(),
          src: src || (fbclid ? "facebook" : gclid ? "google" : "unknown"),
          med: med || (fbclid || gclid ? "paid" : ""),
          camp: camp || "",
          ad: ad || "",
          lp: location.pathname
        };
      }

      // External referrer without UTMs = organic/referral touch
      if (document.referrer) {
        var refHost = new URL(document.referrer).hostname;
        if (refHost && refHost !== location.hostname) {
          return {
            t: Date.now(),
            src: refHost,
            med: "referral",
            camp: "",
            ad: "",
            lp: location.pathname
          };
        }
      }
    } catch (e) {}
    return null;
  }

  function recordTouch() {
    var touch = currentTouch();
    if (!touch) return;
    var chain = readChain();
    var last = chain[chain.length - 1];
    var isDupe =
      last &&
      last.src === touch.src &&
      last.camp === touch.camp &&
      last.ad === touch.ad &&
      touch.t - last.t < DEDUPE_MS;
    if (isDupe) return;
    chain.push(touch);
    if (chain.length > MAX_TOUCHES) chain = chain.slice(chain.length - MAX_TOUCHES);
    saveChain(chain);
    try {
      sessionStorage.removeItem(SYNC_KEY); // chain changed, force re-sync
    } catch (e) {}
  }

  // Human-readable version of the chain for the order's Additional details.
  // Purely cosmetic: the dashboard only parses _journey, never this one.
  function readableChain(chain) {
    try {
      var parts = [];
      for (var i = 0; i < chain.length; i++) {
        var touch = chain[i];
        var label = touch.ad || touch.camp || touch.src || "?";
        if (touch.ad && touch.src) label = touch.src + ": " + touch.ad;
        parts.push(i + 1 + ". " + label);
      }
      var line = parts.join(" → ");
      line += " · " + chain.length + (chain.length === 1 ? " toque" : " toques");
      if (chain.length > 1) {
        var days = Math.floor((chain[chain.length - 1].t - chain[0].t) / 86400000);
        line += " · " + (days < 1 ? "<1 dia" : days + (days === 1 ? " dia" : " dias"));
      }
      return line;
    } catch (e) {
      return "";
    }
  }

  function syncCart() {
    try {
      var chain = readChain();
      if (!chain.length) return;
      var payload = JSON.stringify(chain);
      try {
        if (sessionStorage.getItem(SYNC_KEY) === payload) return;
      } catch (e) {}

      fetch("/cart.js", { credentials: "same-origin" })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          if (!cart || !cart.item_count) return;
          if (
            cart.attributes &&
            cart.attributes._journey === payload &&
            cart.attributes._journey_readable
          ) {
            try { sessionStorage.setItem(SYNC_KEY, payload); } catch (e) {}
            return;
          }
          var attrs = { _journey: payload };
          var readable = readableChain(chain);
          if (readable) attrs._journey_readable = readable;
          return fetch("/cart/update.js", {
            method: "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ attributes: attrs })
          }).then(function () {
            try { sessionStorage.setItem(SYNC_KEY, payload); } catch (e) {}
          });
        })
        .catch(function () {});
    } catch (e) {}
  }

  // Re-sync right after any add-to-cart so the attribute exists even if the
  // buyer goes straight to checkout from the cart drawer (no page reload).
  // Pass-through wrapper: always returns the original fetch promise untouched.
  function watchAddToCart() {
    try {
      var origFetch = window.fetch;
      window.fetch = function () {
        var result = origFetch.apply(this, arguments);
        try {
          var url =
            typeof arguments[0] === "string"
              ? arguments[0]
              : (arguments[0] && arguments[0].url) || "";
          if (url.indexOf("/cart/add") !== -1) {
            result.then(function () { setTimeout(syncCart, 400); }, function () {});
          }
        } catch (e) {}
        return result;
      };
    } catch (e) {}
  }

  try {
    recordTouch();
    watchAddToCart();
    if (document.readyState === "complete" || document.readyState === "interactive") {
      setTimeout(syncCart, 800);
    } else {
      document.addEventListener("DOMContentLoaded", function () {
        setTimeout(syncCart, 800);
      });
    }
  } catch (e) {}
})();
